var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOpenCrystal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#006AF5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2013_14140)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71411 5.83651L11.5 8.74873V13.841L11.0673 14.2196L7.71411 5.83651ZM12.3709 13.079L11.8333 13.5494V7.7717L14.1569 10.3858L13.4855 14.8623L12.3709 13.079ZM14.3763 10.1307L11.9206 7.3682L16.2513 4.58423L17.7881 8.57992L14.3763 10.1307ZM14.4847 10.4476L17.7078 8.98257L17.1994 10.3806L14.8598 11.5504L13.783 15.3384L13.7573 15.2972L14.4847 10.4476ZM14.172 15.9608L14.0212 15.7195L15.0218 12.1995L15.8184 14.3238L13.9355 18.0896L14.172 15.9608ZM16.1104 14.153L15.2087 11.7486L19.5 9.60301V13.7679L16.1104 14.153ZM16.1086 14.4887L19.2991 14.1262L17.2091 16.888L14.0527 19.8333H13.5646L13.821 19.0639L16.1086 14.4887ZM15.1821 19.2354L17.399 17.1667H19.008L15.1821 19.2354ZM15.3956 19.4988L18.9844 17.5584L17.9064 18.852L15.3956 19.4988ZM13.503 18.964L13.2132 19.8333H12.4805L12.1782 17.4149L13.7949 16.3371L13.503 18.964ZM11.8437 17.4265L12.1445 19.8333H11.4478L10.0215 16.1249L11.8437 17.4265ZM9.46933 15.6179L10.6968 18.8092L7.52407 14.3145L8.6883 11.695L10.4932 14.722L9.46933 15.6179ZM8.44253 11.4273L7.22502 14.1667H4.5V10.0141L5.94462 10.4906L8.44253 11.4273ZM10.069 19.8333L4.7357 14.5H7.24697L11.0117 19.8333H10.069ZM6.93096 17.1667L9.09839 19.3341L5.00436 17.1667H6.93096ZM6.0955 19.1803L4.87932 17.4776L9.01433 19.6668L6.0955 19.1803ZM8.77989 11.1978L6.19996 10.2303L7.36503 5.86133L10.8014 14.4523L10.7483 14.4988L8.77989 11.1978ZM12.0033 17.1308L9.93489 15.6534L12.2958 13.5877L13.7729 15.9511L12.0033 17.1308Z",
    fill: "current"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2013_14140"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenCrystal);
export default __webpack_public_path__ + "static/media/OpenCrystal.2cf29aafda57e5ba43a21046f751f14f.svg";
export { ForwardRef as ReactComponent };